import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const RobotVacuumCleanerIcon = createIcon({
  displayName: 'RobotVacuumCleanerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <circle cx="12" cy="12" r="9.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <circle cx="12" cy="9" r="2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <line
        x1="11"
        y1="18"
        x2="13"
        y2="18"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17,3.92093V9a5,5,0,0,1-5,5h0A5,5,0,0,1,7,9V3.92093"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const RobotVacuumCleaner: FC<IconProps> = (props) => {
  return <CustomIcon as={RobotVacuumCleanerIcon} {...props} />
}

export default memo(RobotVacuumCleaner)
